package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.repository.PlaceRepository

/** Atomically flips the `liked` flag on a saved place (detail screen quick-toggle). */
class ToggleLikedUseCase(
    private val repository: PlaceRepository,
) {
    suspend operator fun invoke(placeId: String) {
        repository.toggleLiked(placeId)
    }
}
